import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {GeneralHttpHelperService} from '../../helpers/general-http-helper.service';
import {GetBannerApiData, PostPutBannerApiData} from './banners-http-interfaces';

const BANNERS_API_ROUTES = {
  GET_BANNERS: 'admin/banners',
  GET_BANNERS_LANDING: 'landing/admin/banners',
  GET_BANNERS_WEB_LANDING: 'landing/web/banners/types/:bannerTypes',
  GET_BANNER_WEB_LANDING: 'landing/web/banners/type/:bannerType',
  GET_BANNER: 'admin/banners/:bannerId',
  GET_BANNER_LANDING: 'landing/admin/banners/bannerId',
  POST_BANNER: 'admin/banners',
  POST_BANNER_LANDING: 'landing/admin/banners',
  PUT_BANNER: 'admin/banners/:bannerId',
  PUT_BANNER_LANDING: 'landing/admin/banners/:bannerId',
  DELETE_BANNER: 'admin/banners/:bannerId',
  DELETE_BANNER_LANDING: '/landing/admin/banners/:bannerId',
  GET_BANNER_COMPANY_LINKS: 'admin/get-companies',
  GET_BANNER_CATEGORY_LINKS: 'admin/get-business-categories',
};

@Injectable({
  providedIn: 'root'
})
export class BannersHttpService {


  constructor(private httpClient: HttpClient,
              private generalHttpHelperService: GeneralHttpHelperService) { }
  private getBannersReq(isLanding = false): Observable<any> {
    return this.httpClient.get(isLanding ? BANNERS_API_ROUTES.GET_BANNERS_LANDING : BANNERS_API_ROUTES.GET_BANNERS) as any;
  }

  getBanners(isLanding = false): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getBannersReq(isLanding).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getLandingWebBannersReq(urlParams?: Record<string, any>): Observable<any> {
    const apiUrl = this.generalHttpHelperService.replaceUrlParamsWithValues(BANNERS_API_ROUTES.GET_BANNERS_WEB_LANDING, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getLandingWebBanners(urlParams?: Record<string, any>): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getLandingWebBannersReq(urlParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getLandingWebBannerReq(urlParams?: Record<string, any>): Observable<any> {
    const apiUrl = this.generalHttpHelperService.replaceUrlParamsWithValues(BANNERS_API_ROUTES.GET_BANNER_WEB_LANDING, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getLandingWebBanner(urlParams?: Record<string, any>): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getLandingWebBannerReq(urlParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getBannerReq(urlParams?: Record<string, any>, isLanding = false): Observable<GetBannerApiData> {
    const apiUrl = this.generalHttpHelperService.replaceUrlParamsWithValues(isLanding ? BANNERS_API_ROUTES.GET_BANNER_LANDING : BANNERS_API_ROUTES.GET_BANNER, urlParams);
    return this.httpClient.get(apiUrl) as any;
  }

  getBanner(urlParams?: Record<string, any>, isLanding = false): Promise<GetBannerApiData> {
    return new Promise<GetBannerApiData>((resolve, reject) => {
      this.getBannerReq(urlParams, isLanding).subscribe((res: GetBannerApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private postBannerReq(bodyParams: any, isLanding = false): Observable<PostPutBannerApiData> {
    return this.httpClient.post(isLanding ? BANNERS_API_ROUTES.POST_BANNER_LANDING : BANNERS_API_ROUTES.POST_BANNER, bodyParams) as any;
  }

  postBanner(bodyParams: any, isLanding = false): Promise<PostPutBannerApiData> {
    return new Promise<any>((resolve, reject) => {
      this.postBannerReq(bodyParams, isLanding).subscribe((res: PostPutBannerApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private putBannerReq(urlParam: Record<string, any>, bodyParams: any, isLanding = false): Observable<PostPutBannerApiData> {
    const apiUrl = this.generalHttpHelperService.replaceUrlParamsWithValues(isLanding ? BANNERS_API_ROUTES.PUT_BANNER_LANDING : BANNERS_API_ROUTES.PUT_BANNER, urlParam);
    return this.httpClient.post(apiUrl, bodyParams) as any;
  }

  putBanner(urlParam: Record<string, any>, bodyParams: any, isLanding = false): Promise<PostPutBannerApiData> {
    return new Promise<any>((resolve, reject) => {
      this.putBannerReq(urlParam, bodyParams, isLanding).subscribe((res: PostPutBannerApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private deleteBannerReq(urlParam: Record<string, any>, isLanding = false): Observable<PostPutBannerApiData> {
    const url = this.generalHttpHelperService.replaceUrlParamsWithValues(isLanding ? BANNERS_API_ROUTES.DELETE_BANNER_LANDING : BANNERS_API_ROUTES.DELETE_BANNER, urlParam);
    return this.httpClient.delete(url) as any;
  }

  deleteBanner(urlParam: Record<string, any>, isLanding = false): Promise<PostPutBannerApiData> {
    return new Promise<any>((resolve, reject) => {
      this.deleteBannerReq(urlParam).subscribe((res: PostPutBannerApiData) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }

  private getAutocompleteBannerLinkReq(urlParams: any): Observable<any> {
    let apiUrl = urlParams.linkType === 'company' ? BANNERS_API_ROUTES.GET_BANNER_COMPANY_LINKS : BANNERS_API_ROUTES.GET_BANNER_CATEGORY_LINKS;
    apiUrl = this.generalHttpHelperService.addUrlParams(apiUrl, {searchTerm: urlParams.searchTerm});
    return this.httpClient.get(apiUrl) as any;
  }

  getAutocompleteLink(urlParams: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getAutocompleteBannerLinkReq(urlParams).subscribe((res: any) => {
        resolve(res);
      }, error => {
        reject(error);
      });
    });
  }
}
